import React, { ReactNode } from 'react';
import { Container } from '@material-ui/core';

import { Header } from '../Header/Header';
import styles from './Layout.module.scss';

type Props = {
  children: ReactNode;
};

export function Layout({ children }: Props) {
  return (
    <Container disableGutters>
      <div className={styles.page}>
        <Container>
          <Header />

          <div data-qa-id="pageContent" className={styles.content}>
            {children}
          </div>
        </Container>
      </div>
    </Container>
  );
}
